import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    this.element.addEventListener('click', this.clicked);
  }

  clicked = (event) => {
    this.drawerCheckbox.checked = true;
  }

  get drawerCheckbox() {
    return document.getElementById(this.element.dataset.drawer);
  }

  disconnect() {
  }
}
